import React from "react";
import DocumentsView from "./DocumentsView";

const SubmittalsView = () => <DocumentsView initialTab="submittal" lockedToTab />;

export default SubmittalsView;
